import { render } from "./MemberRuleManagement.vue?vue&type=template&id=cea0d5b2&scoped=true"
import script from "./MemberRuleManagement.vue?vue&type=script&lang=js"
export * from "./MemberRuleManagement.vue?vue&type=script&lang=js"

import "./MemberRuleManagement.vue?vue&type=style&index=0&id=cea0d5b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea0d5b2"]])

export default __exports__